// removed by extract-text-webpack-plugin
module.exports = {"canvas":"styles__canvas__3xuNi"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ParticleSystem/styles.less
// module id = 293
// module chunks = 0